import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { FilterPipe, KeysPipe } from '../../filter.pipe';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../../services/auth/auth.service';
import { WindowService } from '../../services/window/window.service';
import { AngularFireDatabase, snapshotChanges } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable, Subject } from 'rxjs/Rx';
import { User } from '../datamodel/user';
import { ToggleService } from '../../services/toggle/toggle.service';
import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { PaginationService } from '../../services/pagination.service';
import * as _ from 'underscore';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/observable/fromPromise';
import Swal from 'sweetalert2';
interface Notifications {
	type: any;
}
function mapSnapshot(changes: any) {
	return changes.map(a => {
		const data = a.payload.doc.data() as User;
		const id = a.payload.doc.id;
		return { id, ...data };
	});
}

const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		'Authorization': 'key=AIzaSyBDB_jgKH-eDllQnGWTQJiRmQ2vSS0hKag'
	})
};

@Component({
	selector: 'app-notifications',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.scss'],
	providers: [WindowService]
})

export class NotificationsComponent implements OnInit {

	tab = 1;
	setTab(newTab) {
		this.tab = newTab;
	};
	isSet = function (tabNum) {
		return this.tab === tabNum;
	};

	private userRef: AngularFirestoreCollection<User>;
	obsUser: Observable<any>;
	private schedulesRef: AngularFirestoreCollection<any>;
	private notificationsRef: AngularFirestoreCollection<any>;
	private swapsRef: AngularFirestoreCollection<any>;

	private providerRef: AngularFirestoreCollection<any>;
	obsProvider: Observable<any>;

	public notificationsList = [];
	public hospId: string;
	providerId: string;
	public errmsg = "";
	public scheduleLogs = [];
	public schedulePendingLogs = [];
	public scheduleAcceptedLogs = [];
	public scheduleDeniedLogs = [];
	public ngShowhide = false;
	public nRow: string;

	popoverTitle: string = 'Are you sure?';
	popoverMessage: string = 'Are you really <b>sure</b> you want to do this?';
	public confirmClicked: boolean = false;
	public cancelClicked: boolean = false;
	public placement: string = 'left';


	inProcessNotifications = [];
	completedNotifications = [];
	awaitingNotofications = [];

	constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, public toggle: ToggleService, private router: Router, private spinnerService: Ng4LoadingSpinnerService, public http: HttpClient) {
		this.getNotificationsList();
		console.log('notification construtor.....');
	}

	getSubs(coll, id) {
		return this.afs.collection(coll).doc(id).valueChanges()
	}

	ngShowhideDetails = function (flag, rid) {
		if (flag) {
			this.ngShowhide = false;
			this.nRow = rid;
		} else {
			this.ngShowhide = true;
			this.nRow = '';
		}
		//alert(flag);
	};

	dateFormat(dt) {
		dt = new Date(dt);
		let dfm = [
			dt.getFullYear(),
			('0' + (dt.getMonth() + 1)).slice(-2),
			('0' + dt.getDate()).slice(-2)
		].join('-');
		return dfm;
	}

	getNotificationsList() {
		let self = this;
		self.scheduleLogs = [];
		self.schedulePendingLogs = [];
		self.scheduleAcceptedLogs = [];
		self.scheduleDeniedLogs = [];
		let l = 1;
		let lp = 1;
		let la = 1;
		let ld = 1;
		let obs = [];
		let obRecipients = [];
		let nrowData = [];

		let objUser = firebase.auth().currentUser;

		/************************* */
		let results = [];
		let userHospId = "";
		const userRef = this.afs.collection('users').doc(objUser.uid);
		userRef.valueChanges()
			.flatMap(user => {
				userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id) ? user['adminFor'][0].id : '';
				self.schedulesRef = self.afs.collection('schedules', ref => ref.where('instituteRef.id', '==', userHospId));
				return self.schedulesRef.snapshotChanges().map(mapSnapshot);
			})
			.flatMap(schedules => {
				//console.log('schedules',schedules);
				self.notificationsRef = self.afs.collection('notifications', ref => ref.where('institute.id', '==', userHospId).orderBy('created_at', 'desc'));
				return self.notificationsRef.snapshotChanges().map(mapSnapshot).map(n => {
					n.map(_n => {
						_n.schedule = schedules.find(s => {
							return s.id === _n.schedule.id;
						});
						return _n;
					})
					return n;
				});
			}) // get notifications providers
			.flatMap(notifications => {
				let obsArr = [];
				notifications.map(n => {
					if (n.provider.id)
						obsArr.push(this.afs.collection('providers').doc(n.provider.id).valueChanges());
					return n;
				})
				
				if(obsArr.length>0){
					return combineLatest(obsArr).map(arr => {
						notifications.map((n, i) => {
							n.provider = { ...n.provider, ...arr[i] }
							return n;
						})
						return notifications;
					});
				}else{
					return of(notifications);
				}	
			})
			.subscribe(
				(n) => {
					if (n && n.length > 0) {
						n.map(_n => {
							if(!_n.responses){
								let responses = {};
								for(let i in _n.recipients)
									responses[i] = {
										provider : {
											id : i,
											ref : this.afs.collection('providers').doc(i).ref
										}
									}
								_n.responses = responses;
							}
							if (_n.swap_request && _n.swap_request.id){
								_n.swap_request.ref = this.getSubs('swap_requests',_n.swap_request.id);
							}
							if (_n.responses) {
								for (let i in _n.responses)
									if (_n.responses[i].provider) {
										_n.responses[i].provider.ref = this.getSubs('providers', i)
									} else {
										console.warn('Received response without a provider', _n.responses[i]);
									}
							}
							if (_n.accepted_response) {
								if (_n.accepted_response.provider) {
									_n.accepted_response.provider.ref = this.getSubs('providers', _n.accepted_response.provider.id)
								} else {
									console.warn('Received accepted response without a provider:', _n.accepted_response);
								}
							}
							if(_n.provider_schedule){
								_n.provider_schedule.ref = this.getSubs('provider_schedules', _n.provider_schedule.id)
							}
							if(_n.provider.id){
								_n.provider.ref = this.getSubs('providers',_n.provider.id);
							}
							return _n;
						})
						//IF NOTIFICATION TYPE SWAP REQUESTS
						this.inProcessNotifications =
							this.completedNotifications =
							this.awaitingNotofications = [];

						this.inProcessNotifications = this.inProcessNotifications.concat(
							n.filter(_n => _n.type == 'swap_request' && (_n.swap_status == 'pending' || _n.swap_status == 'offered' || _n.swap_status == 'responded'))
						);
						this.completedNotifications = this.completedNotifications.concat(
							n.filter(_n => _n.type == 'swap_request' && (_n.swap_status == 'approved' || _n.swap_status == 'declined'))
						);
						this.awaitingNotofications = this.awaitingNotofications.concat(
							n.filter(_n => _n.type == 'swap_request' && (_n.swap_status == 'accepted'))
						);
						this.completedNotifications = this.completedNotifications.concat(
							n.filter(_n => _n.type == 'shift_request' && _n.shift_request_status == 'approved')
						);
						this.inProcessNotifications = this.inProcessNotifications.concat(
							n.filter(_n => _n.type == 'shift_request' && _n.shift_request_status == 'pending')
						);
						this.awaitingNotofications = this.awaitingNotofications.concat(
							n.filter(_n => _n.type == 'shift_request' && ( _n.shift_request_status == 'accepted'))
						);
						console.log('this.inProcessNotifications',this.inProcessNotifications);
						console.log('this.completedNotifications',this.completedNotifications);
						console.log('this.awaitingNotofications',this.awaitingNotofications);
					}
			});
	}

	ngOnInit() {
		//this.getNotificationsList();
	}

	scrollHandler(e) {
		if (e === 'bottom') {
			//console.log("ghghghg");
		}
	}

	sendPush(hospId, providerId, sdlId, sftId) {
		let self = this;
		var hospRef = this.afs.doc('institutions/' + hospId);
		const document: AngularFirestoreDocument<any> = this.afs.doc('providers/' + providerId);
		const document$: Observable<any> = document.valueChanges();
		document$.subscribe(providers => {
			var nTitle = "Shift assign";
			const idocument: AngularFirestoreDocument<any> = this.afs.doc('institutions/' + hospId);
			const idocument$: Observable<any> = idocument.valueChanges();
			idocument$.subscribe(hspdata => {
				console.log(providers);
				var nMessage = hspdata.name + " has created a new schedule and assigned shift to " + providers.first_name + " " + providers.last_name + ".";
				if (providers.device && providers.device.deviceToken) {
					let message = {
						"notification": {
							"title": nTitle,
							"body": nMessage,
							"sound": "default",
							"click_action": "FCM_PLUGIN_ACTIVITY",
							"icon": "fcm_push_icon"
						},
						"data": {
							"param1": "value1",
							"param2": "value2"
						},
						"to": providers.device.deviceToken,
						"priority": "high",
						"restricted_package_name": ""
					};
					console.log(message);
					this.http
						.post('https://fcm.googleapis.com/fcm/send', message, httpOptions)
						.subscribe(data => {
							console.log(data);
						});
				}
			});
		});
	}

	approveSwapRequest(nid) {
		let self = this;
		//find out the swap details from notifications
		const document: AngularFirestoreDocument<any> = this.afs.doc('notifications/' + nid);
		const document$: Observable<any> = document.valueChanges();
		document$.take(1).subscribe(data => {
			self.spinnerService.show();
			var swapProposeDate = data.accepted_response.selectedDate;
			//find out the details of swap details
			const sdocument: AngularFirestoreDocument<any> = self.afs.doc('swap_requests/' + data.swap_request.id);
			const sdocument$: Observable<any> = sdocument.valueChanges();
			sdocument$.take(1).subscribe(sdata => {
				console.log(sdata);
				//find out the details of provider schedule
				const pdocument: AngularFirestoreDocument<any> = self.afs.doc('provider_schedules/' + sdata.provider_schedule.id);
				const pdocument$: Observable<any> = pdocument.valueChanges();
				pdocument$.take(1).subscribe(pdata => {
					// console.log(pdata);
					// console.log(self.dateFormat(swapProposeDate));
					//get recipient ref
					if (data.accepted_response.provider.id && data.accepted_response.provider.id !== '' && data.accepted_response.provider.id !== 'indefined'){ 
						let recipientRef = this.afs.doc('providers/' + data.accepted_response.provider.id).ref;
						//get the ref of provider schedule of recipient for swapping
						const rdocument = self.afs.collection('provider_schedules', ref => ref.where('provider.id', '==', data.accepted_response.provider.id).where('shift_date_format', '==', self.dateFormat(swapProposeDate)));
						rdocument.snapshotChanges().map(mapSnapshot).take(1).subscribe(shifts => {
							if (shifts.length > 0) {
								console.log('provider schedule 1', sdata.provider_schedule.id);
								//replace provider id
								self.afs.collection('provider_schedules').doc(sdata.provider_schedule.id).update({
									provider: {
										id: data.accepted_response.provider.id,
										ref: recipientRef
									},
									swap_request: firebase.firestore.FieldValue.delete(),
									swap_provider: firebase.firestore.FieldValue.delete(),
									swapping_provider: firebase.firestore.FieldValue.delete(),
									swap_request_status: firebase.firestore.FieldValue.delete(),
									modified: firebase.firestore.FieldValue.serverTimestamp()
								}).then(function (res) {
									let reqProviderRef = self.afs.doc('providers/' + data.provider.id).ref;

									console.log('provider schedule 2', shifts[0].id);

									//replace provider id to proposed shift
									self.afs.collection('provider_schedules').doc(shifts[0].id).update({
										provider: {
											id: data.provider.id,
											ref: reqProviderRef
										},
										swap_request: firebase.firestore.FieldValue.delete(),
										swap_provider: firebase.firestore.FieldValue.delete(),
										swapping_provider: firebase.firestore.FieldValue.delete(),
										swap_request_status: firebase.firestore.FieldValue.delete(),
										modified: firebase.firestore.FieldValue.serverTimestamp()
									}).then(function (resp) {
										console.log("Swap confirmed");
										//update status of swap request
										self.afs.collection('swap_requests').doc(data.swap_request.id).update({
											status: "accepted",
											admin_approval: "approved",
											modified_at: firebase.firestore.FieldValue.serverTimestamp()
										}).then(function (ures) {
											//update status of md_notification data
											self.afs.collection('notifications').doc(nid).update({
												swap_status: "approved",
												admin_approval: "approved",
												modified_at: firebase.firestore.FieldValue.serverTimestamp()
											}).then(function (uresp) {
												
												self.spinnerService.hide();
												Swal({
													type: 'success',
													title: 'Swap request has been approved.',
													showConfirmButton: false,
													timer: 1500
												});
											});
										});
									});
								});
							} else {
								self.spinnerService.hide();
								console.log("No details found for proposed swap date");
								Swal({
									type: 'error',
									title: 'Oops...',
									text: 'No details found for proposed swap date'
								});
							}
						});
					}else{
						self.spinnerService.hide();
						Swal({
							type: 'error',
							title: 'Oops...',
							text: 'Something went wrong!'
						});
					}
				});
			});
		});
	}

	declineSwapRequest(nid) {
		/* let self = this;
		//find out the swap details from notifications
		const document: AngularFirestoreDocument<any> = this.afs.doc('notifications/' + nid);
		const document$: Observable<any> = document.valueChanges();
		document$.take(1).subscribe(data => {
			self.spinnerService.show();
			var swapProposeDate = data.accepted_response.selectedDate;
			//find out the details of swap details
			const sdocument: AngularFirestoreDocument<any> = self.afs.doc('swap_requests/' + data.swap_request.id);
			const sdocument$: Observable<any> = sdocument.valueChanges();
			sdocument$.take(1).subscribe(sdata => {
				console.log(sdata);
				//find out the details of provider schedule
				const pdocument: AngularFirestoreDocument<any> = self.afs.doc('provider_schedules/' + sdata.provider_schedule.id);
				const pdocument$: Observable<any> = pdocument.valueChanges();
				pdocument$.take(1).subscribe(pdata => {
					if (data.accepted_response.provider.id && data.accepted_response.provider.id !== '' && data.accepted_response.provider.id !== 'indefined') { 
						//get recipient ref
						let recipientRef = this.afs.doc('providers/' + data.accepted_response.provider.id).ref;
						//replace provider id
						self.afs.collection('provider_schedules').doc(sdata.provider_schedule.id).update({
							swap_request: firebase.firestore.FieldValue.delete(),
							swap_provider: firebase.firestore.FieldValue.delete(),
							swapping_provider: firebase.firestore.FieldValue.delete(),
							swap_request_status: firebase.firestore.FieldValue.delete(),
							modified: firebase.firestore.FieldValue.serverTimestamp()
						}).then(function (res) {
							
							console.log("Swap declined");
							//update status of swap request
							self.afs.collection('swap_requests').doc(data.swap_request.id).update({
								status: "declined",
								admin_approval: "declined",
								modified_at: firebase.firestore.FieldValue.serverTimestamp()
							}).then(function (ures) {
								//update status of md_notification data
								self.afs.collection('notifications').doc(nid).update({
									swap_status: "declined",
									admin_approval: "declined",
									modified_at: firebase.firestore.FieldValue.serverTimestamp()
								}).then(function (uresp) {
									self.spinnerService.hide();
									Swal({
										type: 'success',
										title: 'Swap request has been declined.',
										showConfirmButton: false,
										timer: 1500
									});
								});
							});
						});
					}else{
						self.spinnerService.hide();
						Swal({
							type: 'error',
							title: 'Oops...',
							text: 'Something went wrong!'
						});
					}
				});
			});
		});*/

		let self = this;
		//find out the swap details from notifications
		const document: AngularFirestoreDocument<any> = this.afs.doc('notifications/' + nid);
		const document$: Observable<any> = document.valueChanges();
		document$.take(1).subscribe(data => {
			self.spinnerService.show();
			var swapProposeDate = data.accepted_response.selectedDate;
			//find out the details of swap details
			const sdocument: AngularFirestoreDocument<any> = self.afs.doc('swap_requests/' + data.swap_request.id);
			const sdocument$: Observable<any> = sdocument.valueChanges();
			sdocument$.take(1).subscribe(sdata => {
				console.log(sdata);
				//find out the details of provider schedule
				const pdocument: AngularFirestoreDocument<any> = self.afs.doc('provider_schedules/' + sdata.provider_schedule.id);
				const pdocument$: Observable<any> = pdocument.valueChanges();
				pdocument$.take(1).subscribe(pdata => {
					// console.log(pdata);
					// console.log(self.dateFormat(swapProposeDate));
					//get recipient ref
					if (data.accepted_response.provider.id && data.accepted_response.provider.id !== '' && data.accepted_response.provider.id !== 'indefined'){ 
						let recipientRef = this.afs.doc('providers/' + data.accepted_response.provider.id).ref;
						//get the ref of provider schedule of recipient for swapping
						const rdocument = self.afs.collection('provider_schedules', ref => ref.where('provider.id', '==', data.accepted_response.provider.id).where('shift_date_format', '==', self.dateFormat(swapProposeDate)));
						rdocument.snapshotChanges().map(mapSnapshot).take(1).subscribe(shifts => {
							if (shifts.length > 0) {
								console.log('provider schedule 1', sdata.provider_schedule.id);
								//replace provider id
								self.afs.collection('provider_schedules').doc(sdata.provider_schedule.id).update({
									swap_request: firebase.firestore.FieldValue.delete(),
									swap_provider: firebase.firestore.FieldValue.delete(),
									swapping_provider: firebase.firestore.FieldValue.delete(),
									swap_request_status: firebase.firestore.FieldValue.delete(),
									modified: firebase.firestore.FieldValue.serverTimestamp()
								}).then(function (res) {
									let reqProviderRef = self.afs.doc('providers/' + data.provider.id).ref;
									//replace provider id to proposed shift
									self.afs.collection('provider_schedules').doc(shifts[0].id).update({
										swap_request: firebase.firestore.FieldValue.delete(),
										swap_provider: firebase.firestore.FieldValue.delete(),
										swapping_provider: firebase.firestore.FieldValue.delete(),
										swap_request_status: firebase.firestore.FieldValue.delete(),
										modified: firebase.firestore.FieldValue.serverTimestamp()
									}).then(function (resp) {
										console.log("Swap confirmed");
										//update status of swap request
										self.afs.collection('swap_requests').doc(data.swap_request.id).update({
											swap_status: "declined",
											admin_approval: "declined",
											modified_at: firebase.firestore.FieldValue.serverTimestamp()
										}).then(function (ures) {
											//update status of md_notification data
											self.afs.collection('notifications').doc(nid).update({
												swap_status: "declined",
												admin_approval: "declined",
												modified_at: firebase.firestore.FieldValue.serverTimestamp()
											}).then(function (uresp) {
												self.spinnerService.hide();
												Swal({
													type: 'success',
													title: 'Swap request has been declined.',
													showConfirmButton: false,
													timer: 1500
												});
											});
										});
									});
								});
							} else {
								self.spinnerService.hide();
								console.log("No details found for proposed swap date");
								Swal({
									type: 'error',
									title: 'Oops...',
									text: 'No details found for proposed swap date'
								});
							}
						});
					}else{
						self.spinnerService.hide();
						Swal({
							type: 'error',
							title: 'Oops...',
							text: 'Something went wrong!'
						});
					}
				});
			});
		});
	}

	// approve shift request
	approveShiftRequest(nobj, resp) {
		let self = this;
		self.spinnerService.show();
		//find out the provider schedule details
		const sdocument: AngularFirestoreDocument<any> = self.afs.doc('provider_schedules/' + nobj.provider_schedule.id);
		const sdocument$: Observable<any> = sdocument.valueChanges();
		sdocument$.take(1).subscribe(pshift => {
			//get the provider details from response
			const pdocument: AngularFirestoreDocument<any> = self.afs.doc('providers/' + resp.provider.id);
			const pdocument$: Observable<any> = pdocument.valueChanges();
			pdocument$.take(1).subscribe(doc => {
				//update provider schedule

				self.afs.collection('provider_schedules').doc(nobj.provider_schedule.id).update({
					provider: {
						id: resp.provider.id,
						ref: self.afs.doc('providers/'+resp.provider.id).ref
					},
					shift_requests : firebase.firestore.FieldValue.delete(),
					modified: firebase.firestore.FieldValue.serverTimestamp()
				}).then(function (d){
					//update notification
					self.afs.collection('notifications').doc(nobj.id).update({
						accepted_response: {
							acceptedAt: firebase.firestore.FieldValue.serverTimestamp(),
							provider: {
								id: resp.provider.id,
								ref: self.afs.doc('providers/' + resp.provider.id).ref
							},
							selectedDate: pshift.shift_date
						},
						shift_request_status: 'approved',
						modified_at: firebase.firestore.FieldValue.serverTimestamp()
					}).then(function(p){
						//send push notification
						if (doc.device && doc.device.deviceToken) {
							var nTitle = "Open Shift Request";
							var nMessage = "Your shift request on " + self.dateFormat(pshift.shift_date) + " has been approved.";
							let message = {
								"notification": {
									"title": nTitle,
									"body": nMessage,
									"sound": "default",
									"click_action": "FCM_PLUGIN_ACTIVITY",
									"icon": "fcm_push_icon"
								},
								"data": {
									"param1": "value1",
									"param2": "value2"
								},
								"to": doc.device.deviceToken,
								"priority": "high",
								"restricted_package_name": ""
							};

							self.http.post('https://fcm.googleapis.com/fcm/send', message, httpOptions).subscribe(fcm => {
							});
						}

						self.spinnerService.hide();
						Swal({
							type: 'success',
							title: 'Shift request has been approved.',
							showConfirmButton: false,
							timer: 1500
						});
					});
				});

			});

		});
	}

	// decline shift request
	declineShiftRequest(nobj, resp) {
		let self = this;
		//find out the provider schedule details
		const sdocument: AngularFirestoreDocument<any> = self.afs.doc('provider_schedules/' + nobj.provider_schedule.id);
		const sdocument$: Observable<any> = sdocument.valueChanges();
		sdocument$.take(1).subscribe(pshift => {
			//get the provider details from response
			const pdocument: AngularFirestoreDocument<any> = self.afs.doc('providers/' + resp.provider.id);
			const pdocument$: Observable<any> = pdocument.valueChanges();
			pdocument$.take(1).subscribe(doc => {
				//update notification
				let objResponse  = {};
              	objResponse[`shift_requests.${resp.provider.id}`] = firebase.firestore.FieldValue.delete();
				 objResponse['modified_at'] =  firebase.firestore.FieldValue.serverTimestamp();
				self.afs.collection('provider_schedules').doc(nobj.provider_schedule.id)
					.update(objResponse)
				.then(res => {
					let objResponse  = {};
              		objResponse[`responses.${resp.provider.id}.status`]  =  'declined';
					objResponse[`responses.${resp.provider.id}.declined_at`]  = firebase.firestore.FieldValue.serverTimestamp();

					self.afs.collection('notifications').doc(nobj.id).update(objResponse).then(function (p) {
						//send push notification
						if (doc.device && doc.device.deviceToken) {
							var nTitle = "Open Shift Request";
							var nMessage = "Your shift request on " + self.dateFormat(pshift.shift_date) + " has been declined.";
							let message = {
								"notification": {
									"title": nTitle,
									"body": nMessage,
									"sound": "default",
									"click_action": "FCM_PLUGIN_ACTIVITY",
									"icon": "fcm_push_icon"
								},
								"data": {
									"param1": "value1",
									"param2": "value2"
								},
								"to": doc.device.deviceToken,
								"priority": "high",
								"restricted_package_name": ""
							};

							self.http.post('https://fcm.googleapis.com/fcm/send', message, httpOptions).subscribe(fcm => {
							});
						}

						self.spinnerService.hide();
						Swal({
							type: 'success',
							title: 'Shift request has been declined.',
							showConfirmButton: false,
							timer: 1500
						});
					});
				});	

			});

		});
		
	}

}


// WEBPACK FOOTER //
// ./src/app/modules/notifications/notifications.component.ts